import { ProductForm as ThemeProductForm } from '@shopify/theme-product-form';
import { cartApi } from '@knitagency/agency-utils';
import { updateReactCart } from '../preact/helpers/utilities';

const selectors = {
  form: '[data-product-form]',
  addToCart: '[data-add-to-cart]',
  quantityInput: '[data-quantity-input]',
};

export default class UpsellItem {
  constructor(productContainer) {
    this.el = productContainer;
    this.formElement = this.el.querySelector(selectors.form);
    const productId = this.el.dataset.productId;
    const metafieldProduct = this.el.dataset.metafieldProduct;

    this.config = {
      onVariantChange: () => {},
      ...pixelThemeSettings.product,
    };

    //TODO: Fetch recommendations from Shopify API

    // if (!metafieldProduct) {
    //   fetch(
    //     `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=1`,
    //   )
    //     .then(response => response.json())
    //     .then(({ products }) => {
    //       if (products.length > 0) {
    //         const firstRecommendedVariant = products[0].variants[0];

    //         alert(
    //           `The title of the first recommended product is: ${firstRecommendedProduct.title}`,
    //         );
    //       }
    //     });
    // }

    fetch(
      `${Shopify.routes.root}products/${this.formElement.dataset.productHandle}.js`,
    )
      .then(response => {
        return response.json();
      })
      .then(productJSON => {
        this.product = productJSON;
        this.themeProductForm = new ThemeProductForm(
          this.formElement,
          productJSON,
          {
            onOptionChange: this._updateVariantState,
            onFormSubmit: this._onFormSubmit,
          },
        );
      });
  }

  /**
   * This function is called whenever the user submits the form
   *
   * @param {*} event
   */
  _onFormSubmit = event => {
    event.preventDefault();

    cartApi
      .add(event.target)
      .then(addedItem => {
        updateReactCart(true);
      })
      .catch(response => this._handleCartApiError(response));
  };

  /**
   * Updates the dom after a variant has changed
   */
  _updateVariantState = () => {
    const variant = this.themeProductForm.variant();
    if (variant === null) {
      this._disableAddToCartState();
      return;
    }
    this.config.onVariantChange(variant);

    if (!variant.available) {
      this._disableAddToCartState();
    } else {
      this._enableAddToCartState();
    }
  };

  /**
   * Generic error handler for cart api
   * Example: 422 response when trying to add a product whose total stock is already in cart
   *
   * @param {Object} response The response from Shopify
   */
  _handleCartApiError = response => {
    const error = response.description;
    alert(error);
  };

  /**
   * disable button state and text
   */
  _disableAddToCartState = () => {
    const { soldOut } = theme.strings.product;
    const button = this.el.querySelector(selectors.addToCart);

    button.setAttribute('disabled', 'disabled');
    button.innerHTML = soldOut;
  };

  /**
   * enable button state and text
   */
  _enableAddToCartState = () => {
    const { addToCart } = theme.strings.product;
    const button = this.el.querySelector(selectors.addToCart);

    button.removeAttribute('disabled');
    button.innerHTML = addToCart;
  };
}
